import Component from '@glimmer/component'
import { service } from '@ember/service'
import { t } from 'ember-intl'
import { PaneHeader } from 'district-ui-client/components/pane/header'
import { ThemedLinkTo } from 'district-ui-client/components/themed-button'
import { posthogEvent } from 'district-ui-client/modifiers/posthog'
import { canAccess } from 'district-ui-client/helpers/can-access'
import { FeatureAccess } from 'district-ui-client/services/feature-control'
import featureFlag from 'district-ui-client/helpers/feature-flag'
import type ExternalRosteringService from 'district-ui-client/services/external-rostering'

export class ManagePane extends Component {
  @service externalRostering!: ExternalRosteringService

  // Districts with an external integration (Clever/ClassLink/FTP/Wonde) manage rostering
  // externally, so the internal 3P Roster page is hidden for them.
  get showRoster(): boolean {
    return this.externalRostering.rostersInRosterApp
  }

  <template>
    <PaneHeader class="mb-8">{{t "sideNav.manage"}}</PaneHeader>
    <div class="flex flex-col gap-5">
      {{#if (featureFlag "dui_rostering_improvements_2026")}}
        {{#if this.showRoster}}
          <ThemedLinkTo
            data-test-manage-roster
            {{posthogEvent "manage-roster"}}
            @style="text"
            @route="subscription-type.manage.roster"
          >{{t "roster"}}</ThemedLinkTo>
        {{/if}}
      {{/if}}
      {{#if (canAccess FeatureAccess.ManageSchools)}}
        <ThemedLinkTo {{posthogEvent "manage-schools"}} @style="text" @route="subscription-type.manage.schools">{{t
            "schools"
          }}</ThemedLinkTo>
      {{/if}}
      {{#if (canAccess FeatureAccess.ManageTeachers)}}
        <ThemedLinkTo {{posthogEvent "manage-teachers"}} @style="text" @route="subscription-type.manage.teachers">{{t
            "teachers"
          }}</ThemedLinkTo>
      {{/if}}
      {{#if (canAccess FeatureAccess.ManageStudents)}}
        <ThemedLinkTo {{posthogEvent "manage-students"}} @style="text" @route="subscription-type.manage.students">{{t
            "students"
          }}</ThemedLinkTo>
      {{/if}}
    </div>
  </template>
}

export default ManagePane
